export default "__VITE_ASSET__DV84Uew3__"